import { Link } from "react-router-dom"

const BreadCrumbs = ({crumbs=[]}) => (
    <nav className="breadcrumbs">
        {crumbs.map((bc, idx, arr) =>
            <span key={idx}>
                {idx === arr.length -1
                        ? <span className="breadcrumb"> {bc.label} </span>
                        : <><Link className="breadcrumb" to={bc.href} > {bc.label} </Link> &nbsp; &gt; &nbsp; </>
                }
            </span>
        )}
    </nav>
)

export default BreadCrumbs